import * as CampaignListActions from './list';
import * as CampaignActions from './campaign';
import * as CampaignQueryActions from './query';
import * as CampaignReportActions from './report';
import * as CampaignPartsActions from './campaignParts';
import * as CampaignTasksActions from './campaignTasks';
import * as CampaignChassisActions from './campaignChassis';

const Actions = {
  ...CampaignActions,
  ...CampaignListActions,
  ...CampaignPartsActions,
  ...CampaignTasksActions,
  ...CampaignQueryActions,
  ...CampaignReportActions,
  ...CampaignChassisActions,
};

export default Actions;
